import { render, staticRenderFns } from "./STableRowItem.vue?vue&type=template&id=90824bc4&scoped=true"
import script from "./STableRowItem.vue?vue&type=script&lang=js"
export * from "./STableRowItem.vue?vue&type=script&lang=js"
import style0 from "./STableRowItem.vue?vue&type=style&index=0&id=90824bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90824bc4",
  null
  
)

export default component.exports